import { activate, deactivate, logger, warn, Level, status } from "@otto-ec/global-debug";
import { o_global } from "../namespaces";

const debug = {
  /*🤫
🤫
🤫
🤫*/
  activate,
  /*🤫
🤫
🤫*/
  deactivate,
  /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
  logger,
  /*🤫
🤫
🤫*/
  Level,
  /*🤫
🤫
🤫*/
  status,

  warn,
};

/*🤫
🤫
🤫*/
export type GlobalDebug = typeof debug;

/*🤫*/
o_global.debug ||= debug;
